export default class Common {
    constructor(client) {
        this.client = client
    }

    toBase64(options) {
        const requestKey = 'common.toBase64'

        return this.client._postMessageWithPromise(requestKey, options)
    }

    exportAsPDF(options) {
        const requestKey = 'common.exportAsPDF'

        options = options || {}

        let linkName = options.linkName || this.client._widget.linkName
        let context = options.context || this.client._context

        delete options.linkName
        delete options.context
        
        let params = {
            linkName: linkName,
            context: context,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }

    exportAsImage(options) {
        const requestKey = 'common.exportAsImage'

        options = options || {}

        let linkName = options.linkName || this.client._widget.linkName
        let context = options.context || this.client._context

        delete options.linkName
        delete options.context

        let params = {
            linkName: linkName,
            context: context,
            options: options
        }

        return this.client._postMessageWithPromise(requestKey, params)
    }
}